<template>
  <div>
    <div class="msg-title">
      <bread-crumb>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ name: 'homePage' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>用户设置</el-breadcrumb-item>
        </el-breadcrumb>
      </bread-crumb>
      <div class="title">用户设置</div>
    </div>
    <div class="setuser">
      <!-- <div class="qymc">用户设置</div> -->
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <!-- <el-tab-pane label="企业信息" name="first">
          <company-msg></company-msg>
        </el-tab-pane>-->
        <el-tab-pane label="绑定手机" name="first">
          <safe-phone v-if="!isShow"></safe-phone>
          <modify-phone v-on:listenmsg="magphone" v-if="isShow"></modify-phone>
        </el-tab-pane>
        <el-tab-pane label="修改密码" name="second" v-if="hasPwd">
          <mdf-password type="change"></mdf-password>
        </el-tab-pane>
        <el-tab-pane label="设置密码" name="second" v-else>
          <mdf-password type="new"></mdf-password>
        </el-tab-pane>
        <!-- <el-tab-pane label="微信绑定" name="fourth">
          <WechatBind></WechatBind>
        </el-tab-pane>
        <el-tab-pane label="数据保存" name="fifth">
          <save-date></save-date>
        </el-tab-pane>-->
      </el-tabs>
    </div>
  </div>
</template>
<script>
import BreadCrumb from "@/components/BreadCrumb";
import SaveDate from "./components/Savedate";
import MdfPassword from "./components/mdfPassword";
import SafePhone from "./components/safePhone";
import companyMsg from "./components/companyMsg";
import modifyPhone from "./components/modifyPhone";
import WechatBind from "./components/WechatBind/WechatBind";
import {getUserPwd} from "@/api/auth";

export default {
  components: {
    BreadCrumb,
    SaveDate,
    MdfPassword,
    SafePhone,
    companyMsg,
    modifyPhone,
    WechatBind,
  },
  data() {
    return {
      activeName: "first",
      hasPwd: false,
      isShow: true,
    };
  },
  async mounted() {
    const bindwx = this.$route.query.bindwx;
    if (bindwx) {
      this.activeName = "fourth";
    }
    const token = JSON.parse(localStorage.getItem("token")).token;
    const res = await getUserPwd(token)
    this.hasPwd = res.data
  },
  methods: {
    handleClick(tab, event) {
      //console.log(tab, event);
    },
    magphone(e) {
      this.isShow = false;
    },
  },
};
</script>
<style src="@/styles/index.styl" lang="stylus" scoped></style>
<style lang="stylus" scoped>
.qymc {
  margin-bottom: 10px;
}

>>> .setuser {
  margin: 0px auto 30px auto;
  // padding: 10px;
  box-sizing: border-box;
  width: 96%;

  .code_btn {
    margin-left: 20px;

    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(47, 84, 235, 1);
    }
  }

  .el-tabs .el-tabs__header {
    margin: 0;

    .el-tabs__nav-wrap::after {
      background-color: none;
      height: 0;
    }

    .el-tabs__nav-wrap {
      .el-tabs__nav-scroll {
        .el-tabs__nav {
          height: 67px;
          line-height: 67px;

          .el-tabs__active-bar {
            // background: #2F54EB;
            height: 36px;
            bottom: 15px;
            border-radius: 18px;
            // width: 88px !important;
            background: none;
          }

          .el-tabs__item {
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.6);
            width: 168px;
            height: 49px;
            line-height: 49px;
            background: rgba(251, 251, 251, 1);
            box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.08);
            border-radius: 18px 18px 0px 0px;
            margin-right: 16px;
            text-align: center;
            padding: 0;
            font-size: 18px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
          }

          .el-tabs__item.is-active {
            // margin-left: 16px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #2F54EB;
            // transition :  all .3s;
            z-index: 3;
            background: rgba(255, 255, 255, 1);
            width: 168px;
            height: 49px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.08);
            border-radius: 18px 18px 0px 0px;
            font-size: 18px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
          }
        }
      }
    }
  }
}

>>> .mdf_content {
  width: 100%;
  margin-left: 99px;
  min-height: 400px;

  .mdf_c1 {
    margin-bottom: 20px;

    span {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(107, 120, 151, 1);
    }

    .mdf_input {
      display: inline-block;
      width: 28%;
      margin-left: 52px;

      .el-input__inner {
        height: 40px;
        background: rgba(255, 255, 255, 1);
        // border: 1px solid rgba(118, 180, 255, 1);
        border-radius: 4px;
      }
    }

    .mdf_input1 {
      margin-left: 20px;
    }
  }
}

.msg-title {
  height: 96px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 1px 0px 0px rgba(238, 238, 238, 1);
}

>>> .bread-crumb-wrapper {
  margin-top: 0;
}

.title {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  // font-weight: 600;
  color: rgba(0, 0, 0, 0.8);
  line-height: 28px;
  margin: 8px 0 0 30px;
}

>>> .el-tabs__nav-scroll {
  display: flex;
  justify-content: center;
  position: relative;
  top: 10px;
}
</style>
